export const PORTAL_ID_VOTING_PANEL_BOTTOM_BAR = 'bottom-bar-portal-id';
export const PORTAL_ID_VOTING_PANEL_BOTTOM_CENTERED_NO_WIDTH =
  'centrally-placed-bottom-no-width-portal-id';
